/**
 * Format YY Coin amount as ruble equivalent.
 *
 * Convention (locked 2026-05-12): 1 YY = 1 ₽.
 * UI shows "299 YY (≈ 299 ₽)" anywhere balances or prices are displayed.
 */
export function formatRuble(coins: number | string): string {
  const n = typeof coins === "string" ? Number(coins) : coins;
  if (!Number.isFinite(n)) return "— ₽";
  const rounded = Math.round(n);
  return `${rounded.toLocaleString("ru-RU")} ₽`;
}

/** "299 YY (≈ 299 ₽)" — when you want both side-by-side. */
export function formatCoinsWithRuble(coins: number | string): string {
  const n = typeof coins === "string" ? Number(coins) : coins;
  if (!Number.isFinite(n)) return "— YY";
  const rounded = Math.round(n * 100) / 100;
  return `${rounded.toLocaleString("ru-RU")} YY (≈ ${formatRuble(coins)})`;
}
